import React from 'react';

import { useAppContext } from '../../../Shared/store/appContext';
import { CustomSnackbar } from '../../../UiComponentsLibrary/CustomSnackbar';
import { CreateBookingPage } from '../CreateBooking/CreateBookingPage';
import BookingConfirmationModal from './components/BookingConfirmationModal/BookingConfirmationModal';
import { BookingCancelModal } from './components/BookingCancelModal';
import BookingRestoreModal from './components/BookingRestoreModal/BookingRestoreModal';
import BookingsSection from './components/BookingsSection/BookingsSection';
import { useQueueSheetManagement } from './hooks/useQueueSheetManagement';
import BookingView from './components/BookingView/BookingView';

const QueueSheetManagement = () => {
  const {
    state: { selectedArtEventId = '' },
  } = useAppContext();
  const artEventId = selectedArtEventId ?? '';

  const {
    viewBookingProps,
    bookingConfirmationModalProps,
    bookingRestoreModalProps,
    bookingCancelModalProps,
    createBookingModalProps,
    customSnackbarProps,
    bookingSectionProps,
  } = useQueueSheetManagement();

  const enhancedBookingSectionProps = {
    ...bookingSectionProps,
    artEventId,
  };

  return (
    <>
      {viewBookingProps.isViewBooking ? (
        <BookingView {...viewBookingProps} />
      ) : createBookingModalProps.isOpen ? (
        <CreateBookingPage {...createBookingModalProps} />
      ) : (
        <>
          <BookingsSection {...enhancedBookingSectionProps} />
          <BookingConfirmationModal {...bookingConfirmationModalProps} />
          <BookingRestoreModal {...bookingRestoreModalProps} />
          <BookingCancelModal {...bookingCancelModalProps} />
          <CustomSnackbar {...customSnackbarProps} />
        </>
      )}
    </>
  );
};
export default QueueSheetManagement;
